import Common from './common.vue'
export default Common



// WEBPACK FOOTER //
// ./src/lib/components/node/common/index.js